import React from 'react';
import { StyledComponentProps, withStyles } from '@material-ui/core';
import { IconButton as MuiButton } from '@material-ui/core';
import { styles } from './styles';
import { ReactComponent as Plus } from '../../images/icons/plus.svg';
import clsx from 'clsx';

interface IProps extends StyledComponentProps {
    onClick: () => any;
    disabled?: boolean;
    className?: any;
}

const NewItemIconButton = (props: IProps) => {
    return (<MuiButton
        disabled={props.disabled}
        className={props.className ? clsx(props.className, props.classes.iconButtonRootSvgBlack) : props.classes.iconButtonRootSvgBlack}
        onClick={props.onClick}>
        <Plus className={props.classes.iconButtonSvgBlack} />
    </MuiButton>)
}


export default withStyles(styles)(NewItemIconButton)